var path = 'widget/widgets-bundles.tpl.html';
var html = " <tb-grid grid-configuration=vm.widgetsBundleGridConfig> <tb-widgets-bundle widgets-bundle=vm.grid.operatingItem() is-edit=vm.grid.detailsConfig.isDetailsEditMode is-read-only=vm.grid.isDetailsReadOnly(vm.grid.operatingItem()) the-form=vm.grid.detailsForm on-export-widgets-bundle=\"vm.exportWidgetsBundle(event, vm.grid.detailsConfig.currentItem)\" on-delete-widgets-bundle=\"vm.grid.deleteItem(event, vm.grid.detailsConfig.currentItem)\"> </tb-widgets-bundle> </tb-grid> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/widget/widgets-bundles.tpl.html
// module id = 1527
// module chunks = 1